import * as types from '../actionTypes/voucherPaymentInternalFilter.actionTypes';
// INIT

const initialState = {
  bankVerifies: [],
  companyBanks: [],
};

const voucherPaymentInternalFilter = (state = initialState, action) => {
  switch (action.type) {
    case types.VOUCHER_PAYMENT_INTERNAL_FILTER.INTERNAL_FILTER_GET_REQUEST_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default voucherPaymentInternalFilter;
